<template>
  <div id="app" class="app" :class="$mq">
    <vue-confirm-dialog class="confirm-dialog"></vue-confirm-dialog>
    <header class="header" :class="getCurrentCategoryColor ? `header--${getCurrentCategoryColor}` : ''">
      <Navbar :showLogoNameOnItsOwn="showLogoNameOnItsOwn" :globalRandomColor="globalRandomColor" />
    </header>
    <main id="top" class="main">
      <router-view :showLogoNameOnItsOwn="showLogoNameOnItsOwn" :globalRandomColor="globalRandomColor" />
    </main>
    <footer class="footer">
      <MainFooter />
    </footer>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import firebase from 'firebase/app';
import MainFooter from './components/MainFooter';
import Navbar from './components/Navbar';
import {DEFAULT_COLOR_SCHEME, DEFAULT_OVERRIDE_OS_DARK_MODE} from './constants/globalConstants';
import getUserDataFromFirebase from './helpers/getUserDataFromFirebase';
import getBoardsDataFromFirebase from './helpers/getBoardsDataFromFirebase';
import {LOGO_COLOR_LIST, LOGO_WITHOUT_NAME_BREAKPOINTS} from './constants/globalConstants';
import isAndroid from './helpers/isAndroid';
import isIOS from './helpers/isIOS';

export default {
  name: 'App',
  components: {
    Navbar,
    MainFooter,
  },
  data() {
    return {
      colorList: LOGO_COLOR_LIST,
      userIsLoggedIn: false,
    };
  },
  computed: {
    ...mapGetters(['getCurrentCategory', 'getCurrentCategoryColor']),
    globalRandomColor: function() {
      const randomIndex = Math.floor(Math.random() * Math.floor(this.colorList.length));
      return this.colorList[randomIndex];
    },
    showLogoNameOnItsOwn: function() {
      return LOGO_WITHOUT_NAME_BREAKPOINTS.includes(this.$mq) && !this.userIsLoggedIn;
    },
  },
  created() {
    if (isIOS()) {
      document.querySelector('body').setAttribute('data-os', 'ios');
    } else if (isAndroid()) {
      document.querySelector('body').setAttribute('data-os', 'android');
    }

    const currentUser = firebase.auth().currentUser;
    if (currentUser && currentUser.emailVerified) {
      this.userIsLoggedIn = true;
      getUserDataFromFirebase(currentUser.uid, currentUserData => {
        this.$store.dispatch('userVuexModule/SET_USER_DATA_FROM_FIREBASE_ACTION', currentUserData);
        localStorage.setItem('overrideOsDarkMode', currentUserData.overrideOsDarkMode);
        localStorage.setItem('prefersColorScheme', currentUserData.prefersColorScheme);
        if (currentUserData.overrideOsDarkMode) {
          document.documentElement.setAttribute('data-theme', currentUserData.prefersColorScheme);
        }
      });
      getBoardsDataFromFirebase(boardsData => {
        this.$store.dispatch('boardsVuexModule/SET_BOARDS_DATA_FROM_FIREBASE_ACTION', boardsData);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.header {
  background-color: var(--color-header-background);
  border-bottom: 1px solid var(--color-header-border-bottom);
  color: var(--color-header-text);
  min-height: var(--min-header-height);
  position: fixed;
  width: 100%;
  z-index: 1;

  &--yellow {
    border-bottom-color: var(--color-yellow);
  }

  &--orange {
    border-bottom-color: var(--color-orange);
  }

  &--pink {
    border-bottom-color: var(--color-pink);
  }

  &--violet {
    border-bottom-color: var(--color-violet);
  }

  &--blue {
    border-bottom-color: var(--color-blue);
  }

  &--green {
    border-bottom-color: var(--color-green);
  }

  &--teal {
    border-bottom-color: var(--color-teal);
  }

  &--brown {
    border-bottom-color: var(--color-brown);
  }

  body.play & {
    display: none;
  }
}
.main {
  flex: 1;
  margin: 0 auto;
  max-width: var(--max-width-site);
  padding: 7.5rem var(--padding-s) var(--padding-xl) var(--padding-s);
  position: relative;
  width: 100%;

  body.play & {
    height: 100vh;
    max-width: none;
    overflow: hidden;
    padding: 0;
    position: relative;
  }
}
.footer {
  background-color: var(--color-footer-background);
  color: var(--color-footer-text);
  border-top: 1px solid var(--color-footer-border-top);

  body.play & {
    display: none;
  }
}
</style>

<style lang="scss">
.confirm-dialog {
  background-color: var(--bg-color-alpha-75);
  max-width: 100vw;
  padding: 1rem;

  .vc-container {
    background-color: var(--bg-color);
    max-width: 39rem;
    width: 100%;
  }

  .vc-text-grid {
    padding: 2rem;
  }

  .vc-text {
    color: var(--text-color);
    font-size: 1.6rem;
    font-weight: 300;
  }

  .vc-btn {
    background-color: var(--bg-color);
    border-top-color: var(--text-color-alpha-33);
    color: var(--text-color);
    font-size: 1.6rem;
    font-weight: 300;
    padding: 2rem;

    &.left {
      border-right-color: var(--text-color-alpha-33);
    }
  }
}
</style>
